<div class="login-box">
  <h2 class="sign-in">{{ "SIGN_IN" | translate }}</h2>
  <p class="login-desc">{{ "SIGN_IN_DESC" | translate }}</p>
  <div *ngIf="userValidate" style="background: #fcefef" class="warning-message">
    <img
      src="./assets/icons/warning.svg"
      alt="password"
      draggable="false"
    /><span>{{ "INCORRECT_CREDENTIALS" | translate }}</span>
  </div>
</div>
<div *ngIf="verifyUser" style="background: #fcefef" class="warning-message">
  <img
    src="./assets/icons/warning.svg"
    alt="password"
    draggable="false"
  /><span>{{ "VERIFY_USER" | translate }}</span>
</div>
<div class="login-form-elements">
  <form [formGroup]="form" class="example-form">
    <div class="email-section">
      <img
        src="./assets/icons/login-email-logo.svg"
        alt="email_logo"
        draggable="false"
      />
      <mat-form-field appearance="fill" class="flex-grow-1">
        <input
          type="email"
          matInput
          formControlName="emailFormControl"
          placeholder="Email"
        />
        <mat-error
          *ngIf="
            form.controls['emailFormControl'] &&
            form.controls['emailFormControl'].hasError('pattern')
          "
        >
          {{ "INVALID_EMAIL" | translate }}</mat-error
        >
        <mat-error
          *ngIf="form.controls['emailFormControl'].hasError('required')"
        >
          {{ "EMAIL_REQUIRED" | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="password-section">
      <img
        src="./assets/icons/login-password-logo.svg"
        alt="password"
        draggable="false"
      />
      <mat-form-field appearance="fill" class="flex-grow-1">
        <input
          [type]="showPassword ? 'text' : 'password'"
          placeholder="{{ 'PASSWORD_PLACEHOLDER' | translate }}"
          matInput
          formControlName="pwdFormControl"
        />
        <mat-error
          *ngIf="
            form.controls['pwdFormControl'].hasError('minLength') &&
            !form.controls['pwdFormControl'].hasError('required')
          "
        >
          {{ "ENTER_VALID_PASSWORD" | translate }}
        </mat-error>
        <mat-error *ngIf="form.controls['pwdFormControl'].hasError('required')">
          {{ "PASSWORD_REQUIRED" | translate }}
        </mat-error>
      </mat-form-field>
      <img
        (keypress)="$event.keyCode == 13 && togglePasswordVisibility()"
        tabindex="0"
        [src]="
          showPassword
            ? './assets/icons/24.svg'
            : './assets/icons/login-show-pwd.svg'
        "
        (click)="togglePasswordVisibility()"
        style="z-index: 5"
        alt="Show Password"
        draggable="false"
      />
    </div>
    <div class="d-flex justify-content-between">
      <a routerLink="reset_password" class="forgot-password">{{
        "FORGOT_PASSWORD" | translate
      }}</a>
      <a  *ngIf="verifyUser" (click)="resentVerifyEmail()" class="resend-btn">{{
        "RESENT_VERIFY_EMAIL_LINK" | translate
      }}</a>
    </div>
    <div class="align-login-btn">
      <button
        type="submit"
        class="btn blue-gredient-btn form-control w-100 justify-content-center"
        mat-button
        mat-flat-button
        (click)="submit()"
        [disabled]="isDisable"
      >
        {{ "LOGIN_BTN" | translate }}
      </button>
    </div>
  </form>
  <p class="botom-action-line">
    {{ "SIGN_UP_LINE" | translate }}
    <a class="sign-up-now" href="/signUp">{{ "SIGN_UP_NOW" | translate }}</a>
  </p>
</div>
